export default __webpack_public_path__ + "static/media/icn-cobotics-registro.e29e0ed4.svg";